import styled from 'styled-components';
const buttonMargin = 24;
export const VolumeContainer = styled.div `
    display: inline-block;
    position: relative;
    margin-right: ${buttonMargin}px;
    line-height: 0;
`;
//# sourceMappingURL=index.js.map